// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';

import resources from 'core/resources/resources';
import { type RolePermission } from 'interfaces/interface';
import type ResourceItem from 'interfaces/resource';
import axiosInstance from 'providers/axiosInstance/axiosInstance';
import useLogger from 'core/utils/useLogger';
import { REACT_APP_USER_API_URL } from 'config';

const fetchPermissions = async (
  setFilteredResources: React.Dispatch<React.SetStateAction<ResourceItem[]>>,
  setCrudPermission: React.Dispatch<React.SetStateAction<string[]>>,
  setModulePermission: React.Dispatch<React.SetStateAction<string[]>>,
  setUserDetails: React.Dispatch<React.SetStateAction<any[]>>,
  changeLanguage: React.Dispatch<React.SetStateAction<any>>,
  setCurrentLang: React.Dispatch<React.SetStateAction<any>>,
  connect: any,
  currentLang: any,
  token: any,
  setOrgId: React.Dispatch<React.SetStateAction<string>>,
  setProgramId: React.Dispatch<React.SetStateAction<string>>,
  userSessionId,
  setRoleList
): Promise<void> => {
  try {
    const response = await axiosInstance.get<RolePermission[]>(
      `${REACT_APP_USER_API_URL}/${apiEndpoint.userEvalPermissionDetails}/`
    );
    const responseData = (response.data as any)?.results;
    const crudPermission = responseData?.action_master_list;
    const userDetails = responseData?.user_details;

    const allOtherPermission =
      responseData.screen_master_list +
      responseData.module_master_list +
      responseData.sub_module_master_list +
      responseData.action_master_list;
    setModulePermission(allOtherPermission);
    setCrudPermission([
      ...crudPermission,
      'profile',
      'overview',
      'cash_and_coupons',
      'coupon_confirmation',
      'inputFileDataCorrection',
      'masterFileDataCorrection',
    ]);

    const newResources = resources.filter((resource: any) =>
      allOtherPermission.includes(resource.identifier)
    );
    setFilteredResources([...newResources]);
    // setFilteredResources(resources);
    setUserDetails(userDetails);
    localStorage.setItem('userEmailId', userDetails?.user_mail_id || '');
    console.log('Permissions:', allOtherPermission);
    if (userDetails?.selected_language) {
      changeLanguage(userDetails?.selected_language);
      setCurrentLang(userDetails?.selected_language);
    }
    if (userDetails?.unique_id) {
      axiosInstance.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
        'organization-id': userDetails?.organization_id,
        'Accept-Language': currentLang,
        'role-id': userDetails?.role_id,
        'iprogram-id': userDetails?.iprogram,
        'user-session-id': userSessionId,
      };
      setOrgId(userDetails?.organization_id);
      setProgramId(userDetails?.iprogram);
      connect(userDetails?.unique_id, userDetails?.organization_id);

      if (
        userDetails?.iprogram_role_mapping?.length > 0 &&
        userDetails?.iprogram
      ) {
        const arr = [];
        userDetails?.iprogram_role_mapping?.forEach((item) => {
          if (item?.iprogram_id === userDetails?.iprogram) {
            arr.push({
              id: item?.role_id,
              label: item?.role_name,
            });
          }
        });
        setRoleList(arr);
      }
    }
  } catch (error) {
    const moduleWithAccess = [
      'dashboard',
      'overview',
      'syncHistory',
      'cash_and_coupons',
      'coupon_confirmation',
    ];
    const newResources = resources.filter((resource: any) =>
      moduleWithAccess.includes(resource.identifier)
    );
    setFilteredResources(newResources);

    if (error?.response?.data) {
      const logger = useLogger();
      logger('User permission details error :: ', error?.response?.data);
    }
  }
};

export default fetchPermissions;
